module.exports = __webpack_public_path__ + "media/images/legitas-e685e65bdfd48af4f097fbaf78484710.png";